import { Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailSupervisorDTO } from '../../../models/renault-animation-action-dto';

@Component({
  selector: 'animation-action-card-supervisor',
  templateUrl: './animation-action-card-supervisor.component.html',
  styleUrls: ['./animation-action-card-supervisor.component.scss']
})
export class AnimationActionCardSupervisorComponent implements OnInit {

  @Input() model: RenaultAnimationActionDetailSupervisorDTO;
  totalRemuneration = 0;
  
  constructor() {   
  }

  ngOnInit(): void {
    this.calculateRemuneration();
  }

  calculateRemuneration() {
    const that = this;
    this.model.RenaultAnimationSubactions.forEach(function (subaction) {
      that.totalRemuneration += subaction.TotalPrice;
    });
  }

}
